import React, { useState, useContext } from "react";
import { BreakpointContext } from "components/common";
import IQHeader from "./Header";
import { LandingDefault } from "./LandingHelper";

const IQLanding = () => {
  const { isBelow } = useContext(BreakpointContext);
  const belowMd = isBelow("md");
  const [renderChat, setRenderChat] = useState(false);

  return (
    <div className="flex flex-col h-screen">
      <IQHeader />
      <div className={`w-full h-full bg-black ${renderChat ? "block" : "hidden"}`}>
        <iframe
          src="https://www.freeform.chat/tomo-credit-companion"
          className="flex-1 border-0 w-full h-full"
          title="chatbot"
        />
      </div>
      {!renderChat && <LandingDefault belowMd={belowMd} setRenderChat={setRenderChat} />}
    </div>
  );
};

export default IQLanding;